'use strict'
import Cover from '../components/Cover.vue'
import LoadingImg from '../components/LoadingImg.vue'
import GobackTop from '../components/GobackTop.vue'
import VCode from '../components/VCode.vue'
import Lunbo from '../components/Lunbo.vue'

import 'babel-polyfill'
import jsaes from 'crypto-js'   //aes
import { JSEncrypt } from 'jsencrypt' //rsa

//import 'url-search-params-polyfill'  //兼容ie10 URLSearchParams


//-------------------
/* import 'es5-shim'
import ES6Promise from "es6-promise" //兼容IE Promise
import 'fetch-detector'
import 'fetch-ie8'
import 'fetch-jsonp'

if (!window.Promise) {
  ES6Promise.polyfill();
} */
//-------------------



const jwebv = {
  install: function (Vue, options) {
    let deletedIds = []
    let indexOf = deletedIds.indexOf

    let rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
    let rnotwhite = (/\S+/g)

    /* ====================全局方法或属性Vue下和实例方法==================== */
    Vue.$dingzc = Vue.prototype.$dingzc = '13521736766'

    Vue.$expando = Vue.prototype.$expando = (Vue.$dingzc + Math.random()).replace(/\D/g, '')

    Vue.$error = Vue.prototype.$error = function (msg) {
      throw new Error('Syntax error, unrecognized expression: ' + msg)
    }

    /* 参数重载 */
    Vue.$extend = Vue.prototype.$extend = (to, _from) => {
      for (var key in _from) {
        to[key] = _from[key]
      }
      return to
    }

    /* 确定JavaScript内置对象的类型，并返回小写形式的类型名称。 */
    Vue.$type = Vue.prototype.$type = function (obj) {
      if (obj === null) {
        return obj + ''
      }
      let temp = Object.prototype.toString.call(obj)
      temp = temp.substring(1, temp.length - 1).toLowerCase()
      return temp.split(' ')[1]
    }

    /* 去空格 支持：Android < 4.1，IE > 9  */
    Vue.$trim = Vue.prototype.$trim = function (text) {
      return text === null ? '' : (text + '').replace(rtrim, '')
    }

    /* 判断指定参数是否是一个空对象 */
    Vue.$isEmptyObject = Vue.prototype.$isEmptyObject = function (obj) {
      var name;
      for (name in obj) {
        return false;
      }
      return true;
    }

    /* 判断数据是否为空 */
    Vue.$isNull = Vue.prototype.$isNull = function (val) {
      switch (Vue.$type(val)) {
        case "string":
          return (val == null || val == undefined || val == "") ? true : false;
        case "array":
          return (val == null || val == undefined || val == [] || val.length == 0) ? true : false;
        case "number":
          return false;
        case "object":
          return Vue.$isEmptyObject(val) ? true : false;
        case "boolean":
          return val;
        case "function":
          return val;
        default:
          return (val == null || val == undefined) ? true : false;
      }
    }

    /* 判断是否存在子节点 */
    Vue.$exist = Vue.prototype.$exist = function (obj) {
      if (typeof obj !== 'undefined' && obj.children.length >= 1) {
        return true
      }
      return false
    }

    let getDepChild = []
    /* 深挖每个子节点的最后一层节点 */
    Vue.$getDepChild = Vue.prototype.$getDepChild = function (obj) {
      let len = obj.children.length
      if (Vue.$exist(obj)) {
        for (let i = 0; i < len; i++) {
          Vue.$getDepChild(obj.children[i])
        }
      } else {
        getDepChild.push(obj)
      }
      return getDepChild
    }

    /* 获取除自己外相邻兄弟节点数组 */
    Vue.$sibling = Vue.prototype.$sibling = function (n, elem) {
      let r = []
      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== elem) {
          r.push(n)
        }
      }
      return r
    }

    function sibling(cur, dir) {
      do {
        cur = cur[dir]
      } while (cur && cur.nodeType !== 1)

      return cur
    }

    /* 下一个节点 */
    Vue.$next = Vue.prototype.$next = function (elem) {
      return sibling(elem, 'nextSibling')
    }

    /* 下一个节点 */
    Vue.$prev = Vue.prototype.$prev = function (elem) {
      return sibling(elem, 'previousSibling')
    }
    // 获得除自己外的兄弟节点
    Vue.$siblings = Vue.prototype.$siblings = function (elem) {
      return Vue.$sibling((elem.parentNode || {}).firstChild, elem)
    }

    // 获取元素所有兄弟节点
    Vue.$children = Vue.prototype.$children = function (elem) {
      return Vue.$sibling(elem.firstChild)
    }

    let rclass = /[\t\r\n\f]/g
    // 添加样式
    Vue.$addClass = Vue.prototype.$addClass = function (obj, value) {
      let classes, elem, cur, clazz, j, finalValue
      let len = Vue.$type(obj) === 'array' ? obj.length : 1
      let proceed = Vue.$type(value) === 'string' && value

      if (proceed) {
        classes = (value || '').match(rnotwhite) || []
        for (let i = 0; i < len; i++) {
          elem = Vue.$type(obj) === 'array' ? obj[i] : obj
          cur = elem.nodeType === 1 && (elem.className ? (' ' + elem.className + ' ').replace(rclass, ' ') : ' ')

          if (cur) {
            j = 0
            while ((clazz = classes[j++])) {
              if (cur.indexOf(' ' + clazz + ' ') < 0) {
                cur += clazz + ' '
              }
            }

            finalValue = Vue.$trim(cur)
            if (elem.className !== finalValue) {
              elem.className = finalValue
            }
          }
        }
      }
    }

    // 删除样式
    Vue.$removeClass = Vue.prototype.$removeClass = function (obj, value) {
      let classes, elem, cur, clazz, j, finalValue
      let i = 0
      let len = Vue.$type(obj) === 'array' ? obj.length : 1
      let proceed = arguments.length === 0 || (Vue.$type(value) === 'string' && value)

      if (proceed) {
        classes = (value || '').match(rnotwhite) || []

        for (; i < len; i++) {
          elem = Vue.$type(obj) === 'array' ? obj[i] : obj

          cur = elem.nodeType === 1 && (elem.className ? (' ' + elem.className + ' ').replace(rclass, ' ') : '')

          if (cur) {
            j = 0
            while ((clazz = classes[j++])) {
              while (cur.indexOf(' ' + clazz + ' ') >= 0) {
                cur = cur.replace(' ' + clazz + ' ', ' ')
              }
            }

            finalValue = value ? Vue.$trim(cur) : ''
            if (elem.className !== finalValue) {
              elem.className = finalValue
            }
          }
        }
      }
    }

    // 公共回调 fn回调函数 data回调数据
    Vue.$callback = Vue.prototype.$callback = function (fn, data) {
      if (fn && Vue.$type(fn) === 'function' && fn(data)) {
        return fn(data)
      }
    }

    // 获取节点
    Vue.$ = Vue.prototype.$ = (id) => {
      let elem
      elem = document.querySelector('#' + id)
      return elem
    };


    Vue.$animate = Vue.prototype.$animate = function (obj, json, interval, sp, fn) {
      clearInterval(obj.timer)
      function getStyle(obj, arr) {
        if (obj.currentStyle) {
          // 针对ie
          return obj.currentStyle[arr]
        } else {
          return document.defaultView.getComputedStyle(obj, null)[arr]
        }
      }
      obj.timer = setInterval(function () {
        var flag = true
        var speed, icur
        for (var arr in json) {
          icur = 0
          if (arr === 'opacity') {
            icur = Math.round(parseFloat(getStyle(obj, arr)) * 100)
          } else {
            icur = parseInt(getStyle(obj, arr))
          }
          speed = (json[arr] - icur) * sp
          speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed)
          if (icur !== json[arr]) {
            flag = false
          }
          if (arr === 'opacity') {
            var temp = icur + speed
            obj.style.filter = 'alpha(opacity : ' + temp + ')'
            obj.style.opacity = (icur + speed) / 100
          } else {
            obj.style[arr] = icur + speed + 'px'
          }
        }

        if (flag) {
          clearInterval(obj.timer)
          if (fn) {
            fn()
          }
        }
      }, interval)
    }


    /* 获取浏览器版本信息-------------------------------------------------------------------------- */
    let checkUA = (arg) => {
      const userAgent = navigator.userAgent
      return userAgent.indexOf(arg) > -1 || !!userAgent.match(arg)
    }
    //是否为IE11
    let isIE11 = () => {
      return ("ActiveXObject" in window) ? ((!window.ActiveXObject) ? true : false) : false;
    }

    let reVersion = (v) => {
      return Vue.$browser.IEVersion() == v ? true : false;
    }
    Vue.$browser = Vue.prototype.$browser = {
      /* 浏览器版本信息 */
      ua: navigator.userAgent,
      /* 页面语言 */
      lang: (navigator.browserLanguage || navigator.language).toLowerCase(),
      v: {
        /* 遨游 */
        maxthon() { return checkUA('Maxthon') },
        /* opera */
        opera() { return checkUA('Opera') },
        /* 火狐浏览器 */
        firefox() { return checkUA('Firefox') },
        /* Chrome浏览器 */
        chrome() { return checkUA('Chrome') && checkUA('Safari') },
        /* Safari浏览器 */
        safari() { return !checkUA('Chrome') && checkUA('Safari') },
        /* IE浏览器 */
        ie() { return (!!window.ActiveXObject || "ActiveXObject" in window) ? true : false; },
        /* 是否为移动终端 */
        mobile() { return checkUA(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) },
        /* ios终端 */
        ios() { return checkUA(/\(i[^;]+;( U;)? CPU.+Mac OS X/) },
        /* android终端或者uc浏览器 */
        android() { return checkUA('Android') || checkUA('Linux') },
        /* 是否为iPhone或者QQHD浏览器 */
        iPhone() { return checkUA('iPhone') },
        /* 是否iPad */
        iPad() { return checkUA('iPad') },
        /* 是否web应该程序，没有头部与底部 */
        webApp() { return !checkUA('Safari') },
        /* 是否微信 */
        weixin() { return checkUA('MicroMessenger') },
        /* 是否QQ */
        qq() { return checkUA(/\sQQ/i) === ' qq' },
        /* 是否windowsphone */
        wp() { return checkUA('Windows Phone') }
      },
      //判断IE浏览器版本
      IEVersion: function () {
        var isIE = Vue.$browser.v.ie();
        if (isIE) {
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(navigator.userAgent);
          var v = parseFloat(RegExp["$1"]);
          if (isIE11()) {
            v = 11;
          }
          return v;
        }
        else {
          return 100;
        }
      },
      IE: {
        ie8() {
          return reVersion(8);
        },
        ie9() {
          return reVersion(9);
        },
        ie10() {
          return reVersion(10);
        },
        ie11() {
          return isIE11();
        }
      },
      width() { return window.innerWidth },
      height() { return window.innerHeight },
      /* 判断pc机（补充方法） */
      isPC() {
        const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
        let flag = true
        for (let v = 0; v < Agents.length; v++) {
          if (checkUA(Agents[v]) > 0) {
            flag = false
            break
          }
        }
        return flag
      },
      /* 是否为支持H5的浏览器 */
      isH5browser() {
        return Vue.$type(Worker) !== 'undefined'
      }
    }

    /* check */
    Vue.$check = Vue.prototype.$check = {
      reNum: /\D/ig,
      rePhone: /^0?1[3|4|5|7|8][0-9]\d{8}$/,
      reMail: /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/,
      reTel: /^0[\d]{2,3}-[\d]{7,8}$/,
      reUserName: /^[a-zA-Z][a-zA-Z0-9_]*$/,
      reCN: /[^\u4E00-\u9FA5]/g,
      reIDCard: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
      reUrl: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/,
      reImg: /.(gif|jpg|jpeg|png)$/,
      reImgBase64: /^data:image\/(jpg|jpeg|png|gif);base64,/,
      // 是否字符串为纯数字
      isNum(txt) { return !this.reNum.test(txt) },
      // 是否为手机号码
      isPhone(txt) { return this.rePhone.test(txt) },
      // 是否为邮件
      isMail(txt) { return this.reMail.test(txt) },
      // 是否为电话号码
      isTel(txt) { return this.reTel.test(txt) },
      // 是否为一般注册帐号
      isUserName(txt) { return this.reUserName.test(txt) },
      // 是否为中文
      isCN(txt) { return !this.reCN.test(txt) },
      // 是否为身份证
      isIDCard(txt) { return this.reIDCard.test(txt) },
      // 是否为Url正式地址
      isUrl(txt) { return this.reUrl.test(txt) },
      // 是否为图片地址
      isImg(txt) { return this.reImg.test(txt) },
      // 是否为base64图片地址
      isImgBase64(txt) { return this.reImgBase64.test(txt) }
    }

    /* string */
    Vue.$string = Vue.prototype.$string = {
      // 是否存在字符串中
      isInStr(substr, str) {
        return new RegExp(substr).test(str)// str.indexOf(substr) >= 0;
      },
      // 判断是否以某个字符串开头
      isStrStart(str, start) {
        return str.indexOf(start) === 0
      },
      // 判断是否以某个字符串结尾
      isStrEnd(str, end) {
        let d = str.length - end.length
        return (d >= 0 && str.lastIndexOf(end) === d)
      },
      // 返回字符串str中特定start到end字符之间的所有内容
      reSelectedStr(str, start, end) {
        let a = str
        let temp = a.split(start)
        let result = []
        for (let i in temp) {
          if (temp[i].indexOf(end) > -1) {
            result.push(temp[i].split(end)[0])
          }
        }
        if (result.length === 1) {
          return result[0]
        } else {
          return result
        }
      },
      // 返回字符串中所有数字
      reStrNum: function (str) {
        return str.replace(/\D/g, '')
      },
      /* 和谐特殊字符
       str 原数据
       array 需要和谐的字符数组 */
      checkLimitChars(str, array) {
        let xn = ''
        let r
        for (let i = 0; i < array.length; i++) {
          r = new RegExp(array[i], 'ig')
          switch (array[i].length) {
            case 1:
              xn = '*'
              break
            case 2:
              xn = '**'
              break
            default:
              xn = '***'
              break
          }
          str = str.replace(r, xn)
        }
        return str
      },
      // 支持：Android < 4.1，IE > 9 去空格
      trim: function (text) {
        return text === null ? '' : (text + '').replace(rtrim, '')
      },
      //返回请求参数xxx=111&xxx=222格式的字符串
      toArgString: (data, encode) => {
        if (Vue.$type(data) == "object") {
          encode = encode == null ? false : encode
          let dataStr = "";
          Object.keys(data).forEach(key => {
            dataStr += key + "=" + (encode ? encodeURIComponent(data[key]) : data[key]) + "&";
          })
          //去除最后一个&
          if (dataStr !== "") {
            dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
          }
          return dataStr;
        }
        else {
          return data;
        }
      }
    }

    Vue.$array = Vue.prototype.$array = {
      //数组去重
      removalArray: function (arr) {
        if (Vue.$type(arr) == "array") {
          //不是IE浏览器使用对象的属性不会重复的特性，效率高
          if (!Vue.$browser.v.ie()) {
            let result = [], obj = {};
            //IE不支持当前写法 严格模式下代码存在都报错，nnd
            for (let i in arr) {
              if (!obj[arr[i]]) {
                result.push(arr[i]);
                obj[arr[i]] = 1;
              }
            }
            result = result.sort();
            return result;
          }
          //IE浏览器使用sort排序后对比相邻数据排重
          else {
            arr = arr.sort();
            let result = [arr[0]];
            for (let i = 1; i < arr.length; i++) {
              arr[i] !== arr[i - 1] && result.push(arr[i]);
            }
            return result;
          }
        }
        else {
          return arr;
        }
      },
      /* 在数组中搜索指定的值，并返回其索引值。不存在返回-1 */
      inArray: function (elem, arr, i) {
        let len
        if (arr) {
          if (indexOf) {
            return indexOf.call(arr, elem, i)
          }
          len = arr.length
          i = i ? i < 0 ? Math.max(0, len + i) : i : 0
          for (; i < len; i++) {
            if (i in arr && arr[i] === elem) {
              return i
            }
          }
        }
        return -1
      },
      /* 合并两个数组，修改第一个参数的内容 */
      merge: function (first, second) {
        return [...first, ...second];
      }
    }

    /* random */
    Vue.$random = Vue.prototype.$random = {
      /* 随机数返回包含起始值 */
      random(start, end) {
        if (Vue.$type(start + end) === 'number') {
          return start > end ? 0 : Math.abs(parseInt(Math.random() * (start - end - 1) + end + 1))
        }
        Vue.$error('the start and end of the params must be a "number" type')
      },
      // 随机数组排列顺序
      randomArr(arr) {
        return Vue.$type(arr) === 'array' ? arr.sort(function () { return 0.5 - Math.random() }) : arr
      },
      // 随机字符串排列顺序
      randomStr(str) {
        return Vue.$type(str) === 'string' ? this.randomArr(str.split('')).join('') : str
      }
    }

    /* method */
    Vue.$method = Vue.prototype.$method = {
      /* 格式化浮点类型数字
       num 原数据
       pos 保留几位小数 */
      fomatFloat: function (num, pos) {
        return Math.round(num * Math.pow(10, pos)) / Math.pow(10, pos)
      },
      /* 检查是否点了除当前对象以外的地方 */
      clickOther: function (el, fn) {
        el = document.querySelector(el)
        el.setAttribute('key', 'clickother')
        document.addEventListener('click', function (e) {
          if (e.path[0].getAttribute('key') !== 'clickother') {
            return setTimeout(fn, 1)
          }
        })
      },
      // 换算移动端屏幕比数据
      reMobileNum: function (num, size) {
        return Vue.$browser.v.mobile ? Math.round((parseInt(num) / (size == null ? 640 : size)) * window.innerWidth) : num
      },
      // 返回时间戳
      getTimeStamp: function () {
        let time = new Date()
        return time.getFullYear().toString() + (time.getMonth() + 1) + time.getTime() + Vue.$expando.substring(Vue.$expando.length - 1, Vue.$expando.length)
      },
      // 获取页面参数
      request: function (paras) {
        let url = location.href
        let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&')
        let paraObj = {}
        let j
        for (let i = 0; i < paraString.length; i++) {
          j = paraString[i]
          paraObj[j.substring(0, j.indexOf('=')).toLowerCase()] = j.substring(j.indexOf('=') + 1, j.length)
        }
        let returnValue = paraObj[paras.toLowerCase()]
        if (typeof (returnValue) === 'undefined') {
          return ''
        } else {
          return returnValue
        }
      },
      // 暂未放入文档中
      getPosition: function (element) {
        let offsety = 0
        offsety += element.offsetTop
        let offsetx = 0
        offsetx += element.offsetLeft
        if (element.offsetParent != null) {
          Vue.$method.getPosition(element.offsetParent)
        }
        return { Left: offsetx, Top: offsety }
      },
      //自定义位数唯一标识符
      uuid: function (length) {
        length = length == null ? 36 : length;
        //拿到时间戳转字符串13位
        let a = new Date().getTime().toString(), uuid = "", b = "1234567890abcdefjhigklmnopqrstuvwxyz", s = [];

        uuid += a;
        //从26个英文字母中随机取出7位字符串
        uuid += Vue.$random.randomStr(b).substring(10, 23);
        //随机出一个10位数的字符串
        uuid += Vue.$random.random(100000, 1000000).toString();
        uuid += Vue.$random.randomStr(b).substring(0, 4);

        if (uuid.length < length) {
          for (var i = 0; i < (length - uuid.length); i++) {
            s[i] = b.substr(Math.floor(Math.random() * 0x10), 1);
          }
        }
        uuid += s.join("");

        uuid = Vue.$random.randomStr(uuid).substr(0, length);

        return uuid;
      },
      //检测横屏竖屏
      orientation: function (fn) {
        let ov = false;
        todo();
        window.onresize = () => {
          todo();
        };
        function todo() {
          // 手机端
          if (window.orientation === 90 || window.orientation === -90 || (Vue.$browser.width() > Vue.$browser.height())) {
            // 默认刷新页面是横屏时
            ov = true;
          } else {
            ov = false;
          }

          if (Vue.$browser.v.mobile()) {
            window.onorientationchange = () => {
              window.orientation === 0 ? ov = false : ov = true;
            };
          } else {
            // 如果是PC端
            ov = false;
          }
          Vue.$callback(fn, ov);
        }
      }
    }

    /* 加密 */
    Vue.$jiami = Vue.prototype.$jiami = {
      aes: function (data, key, iv) {
        //默认上报用的key:1102130405061708 ,有参数的时候使用参数key
        key = key == null ? jsaes.enc.Utf8.parse("1102130405061708") : key = jsaes.enc.Utf8.parse(key);
        iv = iv == null ? key : jsaes.enc.Utf8.parse(iv);
        let confing = {
          iv: iv,
          mode: jsaes.mode.CBC,
          padding: jsaes.pad.Pkcs7
        }
        data = Vue.$type(data) == "object" ? JSON.stringify(data) : data.toString();
        return {
          //加密
          Encrypt: () => jsaes.AES.encrypt(data, key, confing).toString(),
          //解密
          Decrypt: () => jsaes.AES.decrypt(data, key, confing).toString(jsaes.enc.Utf8).toString()
        }
      },
      rsa: function (arg, key) {
        let jsencrypt = new JSEncrypt();
        arg = Vue.$type(arg) == "object" ? JSON.stringify(arg) : arg.toString();
        return {
          Encrypt: function () {
            jsencrypt.setPublicKey(key);
            return jsencrypt.encrypt(arg)
          },
          Decrypt: function () {
            jsencrypt.setPrivateKey(key)
            let data = jsencrypt.decrypt(arg);
            return data;
          }
        }
      }
    }

    /* 联想业务 */
    Vue.$lenovo = Vue.prototype.$lenovo = {
      //aes+rsa加密请求
      aesRsa: function (url, json, fn) {
        var pubkey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCWWmECGlYG0b9lzRKhgKNOtCsNK50ycpnU-dGHkn2vXrPzu7BuoHs5ANzUXNVJRfmlesFWHn73qsM88dBQQLzt_1aVSIvXiUrx_S_ckMxc04kJVzjRUdXb6-VLSWgMtvEVFbzeScS0HGc5OoFh6S2ersAVsdJ9liT9cTYrw4UVyQIDAQAB",
          ranStr16 = Vue.$method.uuid(16);

        var obj = {},
          aesKey = ranStr16;

        if (pubkey.length % 4 !== 0) {
          for (var i = 4 - pubkey.length % 4; i > 0; i--) {
            pubkey += "=";
          }
        }

        pubkey = pubkey.replace(/\-/g, "+");
        pubkey = pubkey.replace(/\_/g, "/");

        var encrypted = Vue.$jiami.rsa(aesKey, pubkey).Encrypt();

        obj.signStr = Vue.$jiami.aes(JSON.stringify(json), aesKey).Encrypt();
        obj.signKey = encrypted;

        Vue.$fetch(url, {
          type: "post",
          contentType: "text",
          data: obj
        }).then(e => {
          Vue.$callback(fn, Vue.$type(e) == "string" ? JSON.parse(Vue.$jiami.aes(e, aesKey).Decrypt()) : e);
        });
      }
    }

    // cookie存储部分
    function cookies() {
      var pluses = /\+/g

      function encode(s) {
        return config.raw ? s : encodeURIComponent(s)
      }

      function decode(s) {
        return config.raw ? s : decodeURIComponent(s)
      }

      function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value))
      }

      function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
          s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\')
        }
        try {
          s = decodeURIComponent(s.replace(pluses, ' '))
          return config.json ? JSON.parse(s) : s
        } catch (e) { }
      }

      function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s)
        return Vue.$type(converter) === 'function' ? converter(value) : value
      }
      var config = {}
      config.set = Vue.$cookie = Vue.prototype.$cookie = function (key, value, options) {
        // 写入
        if (value !== undefined && Vue.$type(value) !== 'function') {
          options = Vue.$extend({}, config.defaults, options)

          if (typeof options.expires === 'number') {
            let days = options.expires
            let t = options.expires = new Date()
            t.setTime(+t + days * 864e+5)
          }

          return (document.cookie = [
            encode(key), '=', stringifyCookieValue(value),
            options.expires ? '; expires=' + options.expires.toUTCString() : '',
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
          ].join(''))
        }

        // 读取
        var result = key ? undefined : {}
        var cookies = document.cookie ? document.cookie.split('; ') : []
        for (var i = 0, l = cookies.length; i < l; i++) {
          var parts = cookies[i].split('=')
          var name = decode(parts.shift())
          var cookie = parts.join('=')

          if (key && key === name) {
            result = read(cookie, value)
            break
          }

          if (!key && (cookie = read(cookie)) !== undefined) {
            result[name] = cookie
          }
        }
        return result
      }

      config.defaults = {}

      // 删除
      config.remove = Vue.$cookie.remove = Vue.prototype.$cookie.remove = function (key, options) {
        if (config.set(key) === undefined) {
          return false
        }

        config.set(key, '', Vue.$extend({}, options, { expires: -1 }))
        return !config.set(key)
      }
      return config
    }
    cookies();


    /* 兼容到IE9数据请求，优先使用fetch，不支持的使用ajax + promise */
    Vue.$fetch = Vue.prototype.$fetch = (url, options) => {
      let temp = {
        type: "GET",
        method: "fetch",
        contentType: "json",
        data: {}
      }
      Vue.$extend(temp, options);

      temp.type = temp.type.toUpperCase();
      // 对于支持fetch方法的浏览器，处理如下：
      if (window.fetch && temp.method == 'fetch') {
        // 此处规定get请求的参数使用时放在data中，如同post请求
        if (temp.type == 'GET') {
          url = url + "?" + Vue.$string.toArgString(temp.data);
        }
        let requestConfig = {
          // fetch默认不会带cookie，需要添加配置项credentials允许携带cookie
          //credentials: 'include',
          method: temp.type,
          /* headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }, */
          mode: "cors", // 以CORS的形式跨域
          //cache: "force-cache"
        }

        if (temp.type == 'POST') {
          let params = new URLSearchParams(Vue.$string.toArgString(temp.data, true));
          Object.defineProperty(requestConfig, 'body', {
            value: params
          });
        }

        try {
          return fetch(url, requestConfig).then(function (res) {
            switch (temp.contentType) {
              case "json":
                return res.json();
              case "text":
                return res.text();
              default:
                return res.json();
            }
          }) // res.json()   res.blob() 不常用
            .catch(error => {
              if (error) throw error;
            });
        } catch (error) {
          throw new Error(error)
        }
      }
      else { // 对于不支持fetch的浏览器，便自动使用 ajax + promise
        return Vue.$ajax(url, temp);
      }
    }

    //XMLHttpRequest请求
    Vue.$ajax = Vue.prototype.$ajax = function (url, options) {
      let temp = {
        type: "GET",
        data: {}
      }
      Vue.$extend(temp, options);

      temp.type = temp.type.toUpperCase();
      let getUrl = "";
      if (temp.type == "GET") {
        getUrl = url + "?" + Vue.$string.toArgString(temp.data);
      }
      return new Promise((resolve, reject) => {
        let requestObj;
        if (window.XMLHttpRequest) {
          requestObj = new XMLHttpRequest();
        } else {
          requestObj = new ActiveXObject("Microsoft.XMLHTTP"); // 兼容IE
        }

        if (temp.type == "POST") {
          let sendData = "";
          sendData = Vue.$string.toArgString(temp.data, true);
          requestObj.open(temp.type, url, true);
          requestObj.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
          requestObj.send(sendData);
        }
        else {
          requestObj.open(temp.type, getUrl, true);
          requestObj.send(null);
        }

        requestObj.onreadystatechange = function () {
          if (requestObj.readyState == 4) {
            if (requestObj.status == 200) {
              let obj = requestObj.response || requestObj.responseText
              try {
                obj = JSON.parse(obj);
              } catch (err) { }
              resolve(obj)
            } else {
              reject(requestObj)
            }
          }
        }
      })
    }


    /* css样式适配操作 */
    Vue.$cssVauleCode = Vue.prototype.$cssVauleCode = (cssdata, options) => {
      let data = {
        size: 640,
        float: 2
      }
      let arrStrCss, strNumCss, arrNumCss
      let allCss = []
      Vue.$extend(data, options)

      /* 检索出要修改的数值 */
      arrNumCss = cssdata.match(/([\d.]+)(?:px)/gi)
      /* 替换要修改的数值为| */
      strNumCss = cssdata.replace(/([\d.]+)(?:px)/gi, '|')
      /* 以|切割成数组 */
      arrStrCss = strNumCss.split('|')

      for (let i in arrNumCss) {
        arrNumCss[i] = Vue.$method.fomatFloat(arrNumCss[i].match(/([\d.]+)/gi) / data.size * Vue.$browser.width(), data.float) + 'px'
        allCss.push(arrStrCss[i] + arrNumCss[i])
      }
      allCss.push(arrStrCss[arrStrCss.length - 1])

      let cssCode = new Promise(function (resolve, reject) {
        let temp = ''
        for (let j in allCss) {
          temp += allCss[j]
        }
        resolve(temp)
      })
      cssCode.then(function (value) {
        Vue.$callback(data.callback, value)
      })
    }

    /* 自动适配移动端尺寸 */
    Vue.$resize = Vue.prototype.$resize = (options) => {
      let data = {
        size: 640,
        float: 2,
        startPos: '#startdom',
        endPos: '#enddom'
      }
      Vue.$extend(data, options)

      if (Vue.$browser.isPC && Vue.$browser.width() >= data.size) {
        return false
      }

      /* 拿到所有style数据 */
      const styleCss = document.getElementsByTagName('style')
      const linkCss = document.getElementsByTagName('link')

      if (styleCss.length > 0) {
        resizeDev(styleCss)
      } else {
        resizeBuild(linkCss)
      }

      /* 打包后执行 */
      function resizeBuild(cssData) {
        let plink = []
        let roundCount = 0
        for (let i = 0; i < cssData.length; i++) {
          if (cssData[i].getAttribute('rel') === 'stylesheet') {
            roundCount++
            plink.push(i)
          }
        }

        let getCount = 0
        let cssArr = ''
        for (let i = 0; i < plink.length; i++) {
          Vue.$ajax({
            url: cssData[plink[i]].getAttribute('href'),
            success: function (e) {
              getCount++
              cssArr += e
              if (getCount === roundCount) {
                setTimeout(function () {
                  todo(cssArr)
                }, 1)
              }
            }
          })
        }
        window.onresize = () => {
          todo(cssArr)
        }

        function todo(str) {
          let head = document.getElementsByTagName('head')[0]
          let link = document.createElement('style')

          let substrCss = ''
          let substrArr = Vue.$string.reSelectedStr(str, data.startPos, data.endPos)
          for (let a in substrArr) {
            substrCss += substrArr[a]
          }

          /* 检索出所有背景图片路径样式 */
          let tempCss = substrCss.replace(/background:url(?=\()[^)]+(?=\))\);/g, ' ')

          /* 传入计算处理方法返回处理数据 */
          Vue.$cssVauleCode(tempCss, {
            size: data.size,
            float: data.float,
            callback: function (e) {
              let id = document.getElementById('resizeStyle')
              if (id) {
                head.removeChild(id)
              }
              link.type = 'text/css'
              link.id = 'resizeStyle'
              link.textContent = e
              head.appendChild(link)
              Vue.$callback(data.callback, 'finish')
            }
          })
        }
      }

      /* 开发模式 */
      function resizeDev(cssData) {
        let textCArr = []
        for (let i = 0; i < cssData.length; i++) {
          textCArr.push(cssData[i].textContent)
        }
        roundDo()
        function roundDo() {
          for (let i = 0; i < cssData.length; i++) {
            let cssContent = textCArr[i]
            /* 如果存在开始和结束标签 */
            if (cssContent.indexOf(data.startPos) > -1 && cssContent.indexOf(data.endPos) > -1) {
              let beforeStr = cssContent.substr(0, cssContent.indexOf(data.startPos))
              let afterStr = cssContent.substr(cssContent.indexOf(data.endPos) + data.endPos.length, cssContent.length)

              /* 传入计算处理方法返回处理数据 */
              Vue.$cssVauleCode(cssContent, {
                size: data.size,
                float: data.float,
                callback: function (e) {
                  cssData[i].textContent = beforeStr + data.startPos + e + data.endPos + afterStr
                  Vue.$callback(data.callback, 'finish')
                }
              })
            } else {
              Vue.$callback(data.callback, 'pass')
            }
          }
        }
        window.onresize = () => {
          roundDo()
        }
      }
    }

    /* 全局自定义全局组件 */
    Vue.component('cover', Cover)/* 遮罩层 */

    Vue.component('loadingImg', LoadingImg)/* 加载图片资源 */

    Vue.component('gobackTop', GobackTop)/* 返回顶部 */

    Vue.component('vcode', VCode)/* 验证码组件 */

    Vue.component('lunbo', Lunbo)/* 轮播组件 */

    /* 全局自定义指令 */
    /* 溢出字符以省略号代替 */
    Vue.directive('shenglue', (el, binding, vnode) => {
      let handler = {
        get: function (target, propKey) {
          if (propKey == "len") {
            return binding.arg || binding.value;
          }
        },
        apply: function (target, thisBinding, args) {
          args[1] = Vue.$isNull(args[1]) ? args[0].length : args[1];
          if (args[1] > 0 && args[1] < args[0].length) {
            return args[0].substring(0, args[1]) + "...";
          }
          else {
            return args[0];
          }
        }
      };

      let slDoit = new Proxy(function (html, len) { }, handler);
      el.innerHTML = slDoit(vnode.children[0].text, slDoit.len);
    })
    /* Vue.directive('shenglue2', {
      //绑定
      bind: function (el, binding, vnode) {
        console.log("bind");
        console.log(el, binding, vnode);
        //el.binding = binding;
        el.innerHTML = strSplit(el.innerHTML, binding.value);
      },
      //更新
      update: function (el, binding, vnode, oldVnode) {
        console.log("update");
        console.log(el, binding, vnode);
        //el.binding = binding;
        el.innerHTML = strSplit(vnode.children[0].text, binding.value);
      },
      //插入
      inserted: function (el, binding, vnode) {
        console.log("inserted")
        console.log(el, binding, vnode);
      },
      //组件已更新
      componentUpdated: function (el, binding, vnode, oldVnode) {
        console.log("componentUpdated");
        console.log(el, binding, vnode);
      },
      //解绑
      unbind: function (el, binding, vnode) {
        console.log("unbind");
        console.log(el, binding, vnode);
      },
    }) */

    /* 缩进0.5em  针对块状元素 */
    Vue.directive('textIndent', (el, binding, vnode) => {
      let arr = ['《', '【']
      let fc
      let obj
      obj = Vue.$getDepChild(el)
      for (let i = 0; i < obj.length; i++) {
        fc = obj[i].innerHTML.substring(0, 1)
        if (Vue.$array.inArray(fc, arr) > -1) {
          obj[i].style.textIndent = '-0.5em'
        }
      }
    })

    /* 禁止双击选中文字 */
    Vue.directive('clearSelect', (el) => {
      el.style.cssText = '-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none;'
      el.onselectstart = function () {
        return false
      }
    })

    /* 微信中禁止容器上下晃动 */
    Vue.directive('wxRepairShake', {
      inserted: function (el, binding, vnode, oldVnode) {
        el.addEventListener('touchstart', function () {
          let top = el.scrollTop
          let totalScroll = el.scrollHeight
          let currentScroll = top + el.offsetHeight

          // 如果我们在容器的顶部或底部滚动，
          // 向上或向下推一个像素。防止滚动条“通过”到身体。
          if (top === 0) {
            el.scrollTop = 1
          } else if (currentScroll === totalScroll) {
            el.scrollTop = top - 1
          }
        })
        el.addEventListener('touchmove', function (evt) {
          // 如果内容实际上是滚动的，即内容足够长滚动可能发生。
          if (el.offsetHeight < el.scrollHeight) {
            evt._isScroller = true
          }
        })

        document.body.addEventListener('touchmove', function (evt) {
          // 在这种情况下，默认行为是滚动主体，其中将导致溢出。因为我们不想这样，我们preventDefault。
          if (!evt._isScroller) {
            evt.preventDefault()
          }
        })
      }
    })

    /* 手势方法 */
    //if (!Vue.$browser.v.ie()) {
    function touchMain(obj, binding, type, vnode) {
      let isPc = Vue.$browser.isPC()
      let swipeEvents = {
        touchstart: isPc ? 'mousedown' : 'touchstart',
        touchmove: isPc ? 'mousemove' : 'touchmove',
        touchend: isPc ? 'mouseup' : 'touchend'
      }
      let startTime, disTime

      let sp = { x: 0, y: 0 }
      let ep = { x: 0, y: 0 }
      let timer = null
      let istouched = true
      let islongtag = false

      let drag
      let isdragstart = false

      obj.addEventListener(swipeEvents.touchstart, function (e) {
        if (type === 'touchstart') {
          Vue.$callback(binding.value, e)
        }
        startTime = new Date()
        isdragstart = true
        if (isPc) {
          sp.x = e.pageX
          sp.y = e.pageY
        } else {
          sp.x = e.changedTouches[0].pageX
          sp.y = e.changedTouches[0].pageY
        }

        istouched = true
        islongtag = false

        timer = setTimeout(() => {
          if (type === 'longtap' && istouched) {
            Vue.$callback(binding.value, e)
            islongtag = true
            clearTimeout(timer)
          }
        }, 1000)
      })

      obj.addEventListener(swipeEvents.touchmove, function (e) {
        if (isPc) {
          ep.x = e.pageX
          ep.y = e.pageY
        } else {
          ep.x = e.changedTouches[0].pageX
          ep.y = e.changedTouches[0].pageY
        }
        // 拖拽 返回坐标对象
        if (type === 'drag' && isdragstart) {
          drag = { x: ep.x - sp.x, y: ep.y - sp.y, e: e }
          Vue.$callback(binding.value, drag)
        }
      })

      obj.addEventListener(swipeEvents.touchend, function (e) {
        if (type === 'touchend') {
          Vue.$callback(binding.value, e)
        }
        disTime = new Date() - startTime
        isdragstart = false
        istouched = false
        clearTimeout(timer)
        if (isPc) {
          ep.x = e.pageX
          ep.y = e.pageY
        } else {
          ep.x = e.changedTouches[0].pageX
          ep.y = e.changedTouches[0].pageY
        }

        let np = { x: 0, y: 0 }
        np.x = ep.x - sp.x
        np.y = ep.y - sp.y

        // 水平方向超过10位移，垂直放放超过20位移，确定是滑动
        if (Math.abs(np.x) > 10 || Math.abs(np.y) > 20) {
          // 水平位移大于垂直位移，确定是水平滑动
          if (Math.abs(np.x) > Math.abs(np.y)) {
            // 结束位置x减去开始x位置为正数且位移大于10，确定右滑
            if (np.x > 10) {
              if (type === 'swiperight') {
                Vue.$callback(binding.value, e)
              }
            }
            // 结束位置x减去开始x位置为负数且位移大于10，确定左滑
            if (np.x < -10) {
              if (type === 'swipeleft') {
                Vue.$callback(binding.value, e)
              }
            }
          } else { // 水平位移小雨垂直位移，确定是上下滑动
            // 同理确定向下滑动
            if (np.y > 10) {
              if (type === 'swipedown') {
                Vue.$callback(binding.value, e)
              }
            }
            // 同理确定向上滑动
            if (np.y < -10) {
              if (type === 'swipeup') {
                Vue.$callback(binding.value, e)
              }
            }
          }
        } else { // 左右小于10位移且上下小于20位移，确定为轻击
          if (type === 'tap' && !islongtag && disTime < 150) {
            Vue.$callback(binding.value, e)
          }
        }
      })

      /* let randomString = () => {
        let len = 10
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        let maxPos = $chars.length
        let pwd = ''
        for (let i = 0; i < len; i++) {
          pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd
      }
      vnode.key = randomString() */
    }

    /* 手势 */
    Vue.directive('touchstart', (el, binding, vnode) => {
      touchMain(el, binding, 'touchstart', vnode)
    })

    Vue.directive('touchend', (el, binding, vnode) => {
      touchMain(el, binding, 'touchend', vnode)
    })

    Vue.directive('tap', (el, binding, vnode) => {
      touchMain(el, binding, 'tap', vnode)
    })

    Vue.directive('longtap', (el, binding, vnode) => {
      touchMain(el, binding, 'longtap', vnode)
    })

    Vue.directive('swipeleft', (el, binding, vnode) => {
      touchMain(el, binding, 'swipeleft', vnode)
    })

    Vue.directive('swiperight', (el, binding, vnode) => {
      touchMain(el, binding, 'swiperight', vnode)
    })

    Vue.directive('swipeup', (el, binding, vnode) => {
      touchMain(el, binding, 'swipeup', vnode)
    })

    Vue.directive('swipedown', (el, binding, vnode) => {
      touchMain(el, binding, 'swipedown', vnode)
    })

    Vue.directive('drag', (el, binding, vnode) => {
      touchMain(el, binding, 'drag', vnode)
    })
    //}

    /* ====================全局mixin方法==================== */
    Vue.mixin({
      created() {
      },
      methods: {

      }
    })
  }
}

// global 情况下 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(jwebv)
}
// 导出模块
export default jwebv



// WEBPACK FOOTER //
// ./src/lib/index.js